import React, { useCallback, useMemo } from 'react';
import { usePrintDispatch, WidgetHeader } from '@mummssoftware/common-ui';
import { Printing } from '@mummssoftware/utils';
import { PrintProgress } from '@mummssoftware/utils/api/Printing';
// import { RegenerateButton, RegenerateButtonProps } from './RegenerateButton';
import { RegenerateButtonProps } from './RegenerateButton';
import { RegenerateProgress } from './RegenerateLoader';

type IdgWidgetHeaderProps = {
  appTitle?: string;
  versionInfo: string;
  smallWidget?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  doNotShow?: boolean;
  keycloak: Keycloak.KeycloakInstance;
  agency: string;
  currentUser: mumms.User;
  patient: mumms.patient | undefined;
  selectedRows: mumms.GenericForm[];
  setSelectedRows: RegenerateButtonProps['setSelectedRows'];
  setRegeneratingIdg: (busy: boolean) => void;
  regeneratingIdg: boolean;
  setRegenerateProgress: (p: RegenerateProgress | null) => void;
  setFetchingPdf: (v: boolean) => void;
  setPrintProgress: (p: PrintProgress | null) => void;
  showPrint: boolean;
};

export const IdgWidgetHeader = ({
  appTitle,
  versionInfo,
  smallWidget,
  onClick,
  onRemove,
  doNotShow,
  keycloak,
  agency,
  currentUser,
  patient,
  selectedRows,
  // setSelectedRows,
  // setRegeneratingIdg,
  // regeneratingIdg,
  // setRegenerateProgress,
  setFetchingPdf,
  setPrintProgress,
  showPrint,
}: IdgWidgetHeaderProps) => {
  const printingService = useMemo(
    () =>
      new Printing({
        url: window.env.hosts.printingService as string,
        keycloak,
        agency,
        currentUser,
      }),
    [keycloak, agency, currentUser],
  );

  const getPrintPromise = useCallback(
    (faxInstructions: any, emailInstructions: any) =>
      printingService.printManifest(
        selectedRows,
        patient as any,
        false,
        (progress: PrintProgress) => setPrintProgress(progress),
        faxInstructions,
        emailInstructions,
      ),
    [printingService, selectedRows, patient, setPrintProgress],
  );

  const onBefore = useCallback(() => setFetchingPdf(true), [setFetchingPdf]);
  const onAfter = useCallback(() => {
    setPrintProgress(null);
    setFetchingPdf(false);
  }, [setPrintProgress, setFetchingPdf]);

  const { print, fax, email } = usePrintDispatch(
    getPrintPromise,
    onBefore,
    onAfter,
  );

  const guardedPrint = () => {
    if (patient) print();
  };
  const guardedFax = () => {
    if (patient) fax();
  };
  const guardedEmail = () => {
    if (patient) email();
  };

  return (
    <WidgetHeader
      appTitle={appTitle ?? ''}
      versionInfo={versionInfo}
      smallWidget={smallWidget}
      onPrint={guardedPrint}
      onFax={guardedFax}
      onEmail={guardedEmail}
      showPrint={showPrint}
      showFax={showPrint}
      onClick={onClick}
      onRemove={onRemove}
      doNotShow={doNotShow}
    >
      {/* release/v2.66/stage: IDG regenerate deferred to a later release
      {showPrint && !smallWidget && (
        <RegenerateButton
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          setRegeneratingIdg={setRegeneratingIdg}
          regeneratingIdg={regeneratingIdg}
          setRegenerateProgress={setRegenerateProgress}
        />
      )}
      */}
    </WidgetHeader>
  );
};
